export default __webpack_public_path__ + "static/media/SIW300H_W00.960f7f71.webp";